<template>
	<VueDatePicker
		:id="context.id"
		ref="datePicker"
		v-model="date"
		:enable-time-picker="false"
		:format="format"
		:placeholder="context.attrs.placeholder || ''"
		:state="context.state.valid"
		:max-date="context.attrs['max'] || null"
		:min-date="context.attrs['min'] || null"
		:ui="{input: `
			shadow-none
			py-2
			pl-4
			pr-9
			${context.state.valid ? 'border-border-primary active:border-border-select' : 'border-functional-success-primary bg-transparent'}
			focus-outline
			hover:!border-border-tertiary
			placeholder:text-body-primary
			bg-background-secondary
			focus:bg-transparent
			font-primary
			typo-body-s
		`}"
		:clearable="false"
		locale="cs"
		auto-apply
		:text-input="{
			format: 'dd. MM. yyyy',
		}"
		:flow="['year', 'month', 'calendar']"
		@update:model-value="handleChange"
	>
		<template #input-icon>
			<NuxtIcon
				name="calendar"
				class="text text-body-tertiary py-2 px-2.5 pr-4 block"
				filled
			/>
		</template>
	</VueDatePicker>
</template>

<script setup lang="ts">
	import VueDatePicker from '@vuepic/vue-datepicker';
	import {useDateFormat} from '@vueuse/core';
	import type {DatepickerContext} from '~/types/formkitDatepicker';

	interface Props {
		context: DatepickerContext
	}

	const props = defineProps<Props>();
	const date = ref(props.context.node.value as Date ?? new Date());

	const datePicker = ref();

	function handleChange(value: DatepickerContext['_value']) {
		const formatted = useDateFormat(value, 'YYYY-MM-DD');
		props.context.node.input(formatted.value);
	}

	function format(date: {getDate: () => any; getMonth: () => number; getFullYear: () => any;}) {
		const day = date.getDate();
		const month = date.getMonth() + 1;
		const year = date.getFullYear();

		return `${day}. ${month}. ${year}`;
	}

	onMounted(() => {
		datePicker.value.clearValue();
	});
</script>

<style scoped>
	@reference "../../assets/css/main.css";

	.dp__main:deep(.dp__input_icon) {
		@apply right-0 left-auto;
	}
</style>
